import {rankingLastYear} from "../constants/ranking";
import {getRankingItemForOffer} from "./get_ranking_items";

export type RankingBadgeVariant = "winner" | "second" | "third" | "recognized";

export interface RankingBadgeForOffer {
    variant: RankingBadgeVariant;
    year: number;
}

/**
 * Resolves badge variant from hardcoded ranking data by `offerId`.
 */
export function getRankingBadgeVariantForOffer(offerId: number, rankingYear: number = rankingLastYear): RankingBadgeVariant | undefined {
    const entry = getRankingItemForOffer(offerId, String(rankingYear));

    if (!entry) {
        return undefined;
    }

    if (entry.regionOrder === 1) {
        return "winner";
    }

    if (entry.regionOrder === 2) {
        return "second";
    }

    if (entry.regionOrder === 3) {
        return "third";
    }

    return "recognized";
}

export function getRankingBadgeForOffer(offerId: number, rankingYear: number = rankingLastYear): RankingBadgeForOffer | undefined {
    const variant = getRankingBadgeVariantForOffer(offerId, rankingYear);

    return variant ? {variant, year: rankingYear} : undefined;
}
import {rankingLastYear} from "../constants/ranking";
import {getRankingItemForOffer} from "./get_ranking_items";

export type RankingBadgeVariant = "winner" | "second" | "third" | "recognized";

export interface RankingBadgeForOffer {
    variant: RankingBadgeVariant;
    year: number;
}

/**
 * Resolves badge variant from hardcoded ranking data by `offerId`.
 */
export function getRankingBadgeVariantForOffer(offerId: number, rankingYear: number = rankingLastYear): RankingBadgeVariant | undefined {
    const entry = getRankingItemForOffer(offerId, String(rankingYear));

    if (!entry) {
        return undefined;
    }

    if (entry.regionOrder === 1) {
        return "winner";
    }

    if (entry.regionOrder === 2) {
        return "second";
    }

    if (entry.regionOrder === 3) {
        return "third";
    }

    return "recognized";
}

export function getRankingBadgeForOffer(offerId: number, rankingYear: number = rankingLastYear): RankingBadgeForOffer | undefined {
    const variant = getRankingBadgeVariantForOffer(offerId, rankingYear);

    return variant ? {variant, year: rankingYear} : undefined;
}
